import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

class AlertMessageModal extends React.Component {

  toggleContent = () => {
    const { toggleContentAction } = this.props;
    toggleContentAction();
  }

  closeModal = () => {
    const { closeModalAction } = this.props;
    closeModalAction();
  }

  render() {
    const {
      isOpen, isExpanded, isCancelable, title, content, width,
      style, className, setReference, onMouseDown, onMouseUp, onTouchStart, onTouchEnd } = this.props;

    const statusModalClassName = (isExpanded) ? 'mdl-layout__alert-message-modal--expanded' : 'mdl-layout__alert-message-modal--retracted';
    const toggleContent = <i className="mdl-layout__alert-message-modal-toggle-icon" onClick={this.toggleContent} />;
    return (
      <Fragment>
        {isOpen &&
          <div
            style={{ ...style, width: `${width}px` }}
            className={
              `mdl-layout__alert-message-modal ${statusModalClassName} ${className}`
            }
            ref={setReference}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
          >
            <div className="mdl-layout__alert-message-modal-header">
              <div className="mdl-layout__alert-message-modal-title">
                { isCancelable && toggleContent }
                { title }
              </div>
              { !isExpanded && <span className="mdl-layout__alert-message-modal-truncated-text">  - { content } </span>}
              { isCancelable && <i className="mdl-layout__alert-message-modal-close-icon" onClick={this.closeModal} />}
              { !isCancelable && toggleContent}
            </div>
            <div className="mdl-layout__alert-message-modal-body">
              <p> { content } </p>
            </div>
          </div>
        }
      </Fragment>
    );
  }
}

AlertMessageModal.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.node.isRequired]),
  isOpen: PropTypes.bool.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  isCancelable: PropTypes.bool.isRequired,
  toggleContentAction: PropTypes.func,
  closeModalAction: PropTypes.func,
  width: PropTypes.number.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  setReference: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onTouchStart: PropTypes.func,
  onTouchEnd: PropTypes.func
};

AlertMessageModal.defaultProps = {
  width: 400,
  isOpen: false,
  isExpanded: true,
  isCancelable: true,
  className: ''
};

export default AlertMessageModal;
